export const parseDynamicLabel = (label) => {
  if (!label || typeof label !== 'string') return {};
  
  const cleanLabel = label.replace(/^{\s*/, '').replace(/\s*}$/, '');
  const pairs = cleanLabel.split(',').map(pair => pair.trim());
  
  const parsed = {};
  pairs.forEach(pair => {
    const [key, ...valueParts] = pair.split('=').map(part => part.trim());
    const value = valueParts.join('=').trim();
    if (key && value !== undefined) {
      parsed[key] = value;
    }
  });
  
  return parsed;
};

export const getDynamicColumns = (results) => {
  if (!Array.isArray(results) || results.length === 0) return [];
  
  const firstItem = results[0];
  if (!firstItem.label) return [];
  
  const parsed = parseDynamicLabel(firstItem.label);
  return Object.keys(parsed);
};

export const getMetricName = (executedMetric, executedMetricColumn, selectedTableInfo) => {
  const metricNames = ['Pedidos', 'Suma', 'Promedio'];
  const metricType = metricNames[executedMetric] || 'Valor';
  
  if (executedMetric === 0 || !executedMetricColumn) {
    return metricType;
  }
  
  const metricsColumns = selectedTableInfo?.columns?.metrics || [];
  const column = metricsColumns.find(col => col.name === executedMetricColumn);
  const columnName = column?.displayName || executedMetricColumn;
  
  return `${metricType} de ${columnName}`;
};

export const hasIncompleteFilters = (filterGroups) => {
  return filterGroups.some(group => 
    group.filters.some(filter => {
      if (!filter.fieldName) return true;
      if (filter.operator === 8 || filter.operator === 9) return false;
      return !filter.value;
    })
  );
};

export const getValidationMessage = (loading, selectedTable, filterGroups) => {
  if (loading) return null;
  if (!selectedTable) return 'Selecciona una fuente de datos';
  if (hasIncompleteFilters(filterGroups)) return 'Completa todos los filtros o elimínalos';
  return null;
};

export const getDimensionName = (dimension) => {
  const dimensionNames = [
    'Sin agrupar', 'Comercial', 'Transportista', 'Cliente', 'Producto', 
    'Categoría de Producto', 'Franja Horaria', 'Tipo de Incidencia', 
    'Acción de Incidencia', 'Origen del Cliente', 'Método de Pago'
  ];
  return dimensionNames[dimension] || 'Agrupar por';
};

export const shouldUseDropdown = (fieldName, dropdownOptions) => {
  return dropdownOptions.hasOwnProperty(fieldName);
};

export const shouldSendTextValue = (fieldName) => {
  return ['ProductType', 'ProductModel', 'ProductColor', 'ProductSize', 'ZipCode'].includes(fieldName);
};

export const shouldUseClientModal = (fieldName) => {
  return fieldName === 'ClientId';
};

export const getDropdownOptionsForField = (fieldName, dropdownOptions) => {
  return dropdownOptions[fieldName] || [];
};

export const getColumnDatabaseName = (friendlyName, dynamicColumns, executedDimension) => {
  // Mapeo de nombres friendly a nombres de base de datos
  const columnMapping = {
    'Pedidos': 'count',
    'Suma': 'sum', 
    'Promedio': 'average',
    'Productos Total': 'quantityCount',
    'Productos Promedio': 'quantityAverage',
    'Código Postal': 'ZipCode',
    'Ciudad': 'City',
    'Provincia': 'Province',
    'País': 'Country',
    'Nombre Comercial': 'SalesRepName',
    'Nombre Transportista': 'CarrierName',
    'Nombre Cliente': 'ClientName',
    'Categoría': 'CategoryName',
    'Tipo': 'TypeName',
    'Modelo': 'ModelName',
    'Color': 'ColorName',
    'Tamaño': 'Size'
  };
  
  // Si es una columna estática, usar el mapeo
  if (columnMapping[friendlyName]) {
    return columnMapping[friendlyName];
  }
  
  // Si es la columna de etiqueta principal
  if (friendlyName === 'label') {
    const dimensionMapping = {
      1: 'SalesRepId',
      2: 'CarrierId', 
      3: 'ClientId',
      4: 'ProductTypeId',
      5: 'ProductCategoryId',
      6: 'TimeSlotId',
      7: 'IncidentTypeId',
      8: 'IncidentActionId',
      9: 'ClientOriginId',
      10: 'PaymentMethodId'
    };
    return dimensionMapping[executedDimension] || 'label';
  }
  
  return friendlyName;
};